import React, { useContext } from 'react';

import { AppContext } from 'context';
import { Navigate, Outlet } from 'react-router-dom';

const AuthRoute = ({ props }) => {
	const { authenticated, currentUser } = useContext(AppContext);

	// Only redirect to login if we're sure the user is not authenticated
	if (authenticated === false) {
		return <Navigate to="/login" />;
	}

	// If we have a currentUser, render the protected route
	if (currentUser) {
		return <Outlet {...props} />;
	}

	// If we're still loading (authenticated is undefined), don't redirect yet
	return null;
};

export default AuthRoute;
